import { IContactProfile } from 'apps/wrapper/src/services/api-client/interface';
import { FC } from 'react';
import { CallAction } from './actions/call-action';
import { MessengerAction } from './actions/messenger-action';

type ContactActionsProps = {
  contact: IContactProfile;
  onClose: () => void;
};

export const ContactActions: FC<ContactActionsProps> = (props) => {
  const { contact, onClose } = props;

  return (
    <>
      <CallAction contact={contact} onClick={onClose} />
      <MessengerAction contact={contact} onClick={onClose} />
    </>
  );
};
